/* eslint-disable no-unneeded-ternary */
import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';
import Logo from '../Logo';
import TextQuestion from '../TextQuestion';

import './login.scss';

class LogIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      error: '',
    };
  }

  componentDidMount = () => {
    this.checkAndRedirectPasswordResetModal();
  }

  getModalContent = () => {
    const modalStage = this.getModalStage();

    let error = null;

    if (this.state.error) {
      error = (
        <small className="error-text">{this.state.error}</small>
      );
    }

    if (modalStage === 'loadingState') {
      return (
        <div className="loading-container">
          <div className="pulsing-logo">
            <Logo />
          </div>
        </div>
      );
    }

    if (modalStage === 'forgotPassword') {
      return (
        <div>
          <h1>Forgot password</h1>
          <form onSubmit={this.sendRecoveryEmail}>
            <p className="reset-password-text">Enter your email and we&#39;ll send you a password reset code.</p>
            <TextQuestion name="email" onChange={this.updateField} type="email" header="Email" placeholder="Enter your email" />
            {error}
            <div className="submit-bottom">
              <button type="submit" className="submit-button">Submit</button>
              {/* eslint-disable-next-line */}
              <p onClick={this.goToLogIn} className="login-bottom-text password-remember">Oops, I remember my password.</p>
            </div>
          </form>
        </div>
      );
    }

    if (modalStage === 'forgotPasswordSuccess') {
      return (
        <div>
          <h1>Reset link sent</h1>
          <p>Please check your inbox.</p>
        </div>
      );
    }

    if (modalStage === 'resetPassword') {
      return (
        <div>
          <h1>New Password</h1>
          <form onSubmit={this.attemptResetPassword}>
            <p className="reset-password-text">Enter new password</p>
            <TextQuestion name="password" onChange={this.updateField} type="password" header="Password" placeholder="Password (minimum 8 characters)" />
            {error}
            <div className="submit-bottom">
              <button type="submit" className="submit-button">Submit</button>
            </div>
          </form>
        </div>
      );
    }

    // If isn't in any special state just returns the regular form.

    return (
      <div>
        <h1>Sign in</h1>
        <form onSubmit={this.attemptLogin}>
          <TextQuestion error={error ? true : false} name="email" onChange={this.updateField} type="email" header="Email" placeholder="Enter your email" />
          <TextQuestion error={error ? true : false} name="password" onChange={this.updateField} type="password" header="Password" placeholder="Enter your password" />
          {/* eslint-disable-next-line */}
          <small onClick={this.goToForgotPassword} className="forgot-password-text">Forgot your password?</small>
          {error}
          <div className="submit-bottom">
            <button type="submit" className="submit-button">Sign in</button>
          </div>
        </form>
      </div>
    );
  }

  getModalStage = () => {
    if (this.state.modalStage === 1) {
      return 'loadingState';
    }

    if (this.state.modalStage === 2) {
      return 'forgotPassword';
    }

    if (this.state.modalStage === 3) {
      return 'forgotPasswordSuccess';
    }

    if (this.state.modalStage === 4) {
      return 'resetPassword';
    }

    return 'startApplication';
  }

  attemptLogin = (event) => {
    if (event) {
      try {
        event.preventDefault();
      } catch (error) {
        // Woo
      }
    }

    this.clearError();
    window.HackerAPI.Auth.login(this.state.email.replace(' ', '+'), this.state.password)
      .then((auth) => {
        this.redirect(auth.token);
      })
      .catch(() => {
        this.throwError('That username or password was incorrect.');
      });
  }

  sendRecoveryEmail = (event) => {
    event.preventDefault();
    this.clearError();

    window.HackerAPI.Auth.resetPassword(this.state.email, 'https://hackthenorth.com/', false)
      .then(this.goToForgotPasswordSuccess)
      .catch(() => this.throwError('Something went wrong!'));
  }

  checkAndRedirectPasswordResetModal = () => {
    const url = new URL(window.location.href);

    const token = url.searchParams.get('token');
    const email = url.searchParams.get('email');

    if (token && email) {
      this.setState({
        email,
        token,
      });
      setTimeout(() => {
        this.goToResetPassword();
      }, 50);
    }
  }

  // Use this
  attemptResetPassword = (event) => {
    if (event) {
      event.preventDefault();
    }

    window.HackerAPI.Auth.setPassword(this.state.email.replace(' ', '+'), this.state.password, this.state.token)
      .then(this.attemptLogin)
      .catch(() => {
        this.throwError('Your password could not be reset.');
      });
  }

  goToResetPassword = () => {
    this.clearError();
    this.setState({ modalStage: 4 });
  }

  goToForgotPasswordSuccess = () => {
    this.clearError();
    this.setState({ modalStage: 3 });
  }

  goToForgotPassword = () => {
    this.clearError();
    this.setState({ modalStage: 2 });
  }

  goToLoading = () => {
    this.clearError();
    this.setState({ modalStage: 1 });
  }

  goToLogIn = () => {
    this.clearError();
    this.setState({ modalStage: 0 });
  }

  redirect = (authToken) => {
    window.location.href = `https://app.hackthenorth.com/?token=${authToken}`;
  }

  updateField = (name, value) => {
    const newState = this.state;
    newState[name] = value;
    this.setState(newState);
  }

  throwError = (error) => {
    this.setState({ error });
  }

  clearError = () => {
    this.setState({ error: '' });
  }

  render() {
    return (
      <Modal show={this.props.show} toggle={this.props.toggle}>
        {this.getModalContent()}
      </Modal>
    );
  }
}

export default LogIn;

LogIn.propTypes = {
  show: PropTypes.bool.isRequired, // eslint-disable-line react/forbid-prop-types
  toggle: PropTypes.func.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/components/LogIn/index.jsx